export default __webpack_public_path__ + "static/media/calling.1cf780f6.ogg";